import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  useFormContext,
} from "react-hook-form";
import { TextFieldProps } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useMemo } from "react";
import RHFTextField from "./RHFTextField";

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  readOnly?: boolean;
  datePickerProps?: any;
};

type Props = IProps & TextFieldProps;
export type RHFDatePickerProps = Props;

const RHFDatePicker = ({ name, readOnly, datePickerProps, ...other }: Props) => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const value: Date | null = watch(name);

  const isError = useMemo(() => {
    return !!errors[name];
  }, [errors, name]);
  const errorMessage = useMemo(() => {
    return errors[name]?.message ?? "";
  }, [errors, name]);

  if (readOnly) {
    return <RHFTextField name={name} readOnly {...other} variant="standard" />;
  }

  const render = ({
    field,
    fieldState,
  }: {
    field: ControllerRenderProps<FieldValues, string>;
    fieldState: ControllerFieldState;
  }) => {
    return (
      <DatePicker
        slotProps={{
          actionBar: {
            actions: ["accept", "clear", "cancel"],
          },
          inputAdornment: {
            position: "start",
          },
          textField: {
            size: "small",
            error: isError,
            helperText: errorMessage,
          },
        }}
        {...field}
        {...other}
        {...datePickerProps}
      />
    );
  };

  return <Controller name={name} control={control} render={render} />;
};

export default React.memo(RHFDatePicker);
